/**
 * 接口域名的管理
 */
// 正式配置
// const base = {
//
//   //sq:'/api',//请求代理需要用到
//     sq:'http://wechat.nxptdn.com',
//     bd: 'http://operator.nxptdn.com',
//     client:'http://e.nxptdn.com',
//     appid:'wx65810fb2381de672'
// }


//演示环境 
const base = {
  // bd: '/api',
  bd: '/prod-cloud-api',

  client: 'http://hzgj-h5.huizhidata.com',
}





export default base;


